import { render, staticRenderFns } from "./programUsulan.vue?vue&type=template&id=f8871052&"
import script from "./programUsulan.vue?vue&type=script&lang=js&"
export * from "./programUsulan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QInput,QIcon,QBtn,QList,QExpansionItem,QItemSection,QAvatar,QCard,QCardSection,QSeparator,QPagination} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QInput,QIcon,QBtn,QList,QExpansionItem,QItemSection,QAvatar,QCard,QCardSection,QSeparator,QPagination})
